<template>
    <v-app id="inspire">
        <v-app-bar app clipped-left height="50">
            <v-toolbar-title>Lezení</v-toolbar-title>
        </v-app-bar>

        <v-content>
            <MapyCzMap/>
        </v-content>
    </v-app>
</template>

<script>
    import MapyCzMap from "./components/MapyCzMap";

    export default {
        components: {
            "MapyCzMap": MapyCzMap
        },
        props: {},
        data: () => ({}),
        created() {
            this.$vuetify.theme.dark = true
        },
    }
</script>
